import { formatoHora12, horaLocal, type DetallesChoque, type SlotDisponible } from '@barbones/shared';
import { CalendarSearch } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  barbero: string;
  choque: DetallesChoque;
  /** Mientras se guarda la opción elegida. */
  ocupado: boolean;
  /** Hora local `HH:mm` elegida: se guarda de inmediato. */
  onElegir: (hora: string) => void;
  onVerAgenda: () => void;
}

/** Hora que choca: agendar en el hueco libre anterior o posterior, o ver la agenda del barbero. */
export function PanelChoque({ barbero, choque, ocupado, onElegir, onVerAgenda }: Props) {
  const opcion = (slot: SlotDisponible | null, cuando: 'antes' | 'después') => {
    if (!slot) {
      return (
        <Button variante="secundario" disabled>
          Sin horario disponible {cuando}
        </Button>
      );
    }
    const hora = horaLocal(new Date(slot.inicio));
    return (
      <Button variante="secundario" disabled={ocupado} onClick={() => onElegir(hora)}>
        Agendar {cuando} · {formatoHora12(hora)}
      </Button>
    );
  };

  return (
    <div role="alert" className="flex flex-col gap-2 rounded-md bg-warning-soft px-3 py-2.5">
      <p className="text-[13px] font-medium text-warning">Ese horario ya está ocupado para {barbero}</p>
      <div className="flex flex-wrap gap-2">
        {opcion(choque.antes, 'antes')}
        {opcion(choque.despues, 'después')}
        <Button variante="fantasma" disabled={ocupado} onClick={onVerAgenda}>
          <CalendarSearch /> Ver agenda de {barbero}
        </Button>
      </div>
    </div>
  );
}
